import Vue from 'vue'
import store from './store'
import { camelize } from '@/services/camelize'
import router from "@/router";

const instances = []

export function convertAllElements(componentsByName) {
    Object.keys(componentsByName).forEach(name => {
        if (name === 'domains') {
            Object.keys(componentsByName[name]).forEach(domain => {
                Object.keys(componentsByName[name][domain]).forEach(dcn => {
                    convertTags(`${domain}${dcn}`, componentsByName[name][domain][dcn]);
                });
            });
        } else {
            convertTags(name, componentsByName[name]);
        }
    });
}

export function convertElement(element, componentsByName, config = {}) {
    if(!element) {
        return;
    }
    const componentName = element.getAttribute('data-vue-component')
    const component = getComponentByName(componentName, componentsByName)
    const options = buildOptions(element, component, config)
    
    makeInstance(options)
}

export function destroyElement(element) {
    const component = findComponentByElement(element)

    if (component) {
        component.$destroy()
    }
}

function findComponentByElement(element) {
    return instances.find(instance => instance.$el == element)
}

function convertTags(name, component) {
    const elements = [
        ...getElementsByTagName(name),
        ...getElementsByComponentAttribute(name)
    ]
    elements
        .map(element => buildOptions(element, component))
        .forEach(options => makeInstance(options))
}

function makeInstance(options) {
    const instance = new Vue(options)
    instances.push(instance)
    return instance
}

function getElementsByTagName(tagName) {
    return [].slice.call(document.getElementsByTagName(tagName))
}

function getElementsByComponentAttribute(name) {
    return Array.from(document.querySelectorAll('[data-vue-component]'))
        .filter(el => el.getAttribute('data-vue-component') === name)
}

function buildOptions(element, component, { props = {}, on = {} } = {}) {
    return {
        el: element,
        store,
        router,
        data: {
            rootProps: props,
        },
        render(createElement) {
            return createElement(component, {
                props: { ...this.rootProps, ...extractAttributeProps(element) },
                on,
                class: element.className || '',
            })
        }
    }
}

function extractAttributeProps(element) {
    const props = {
        appEmitter: new Vue()
    };

    [].slice.call(element.attributes)
        .filter(attr => attr.name.match(/^data-/))
        .forEach(({ name, value }) => {
            const propName = camelize(name.replace(/^data-/, ''))
            props[propName] = value
        })

    return props
}

export function getComponentByName(name, components) {
    let component = components[name];
    
    if (components.hasOwnProperty('domains')) {
        if (components.domains[Object.keys(components.domains)[0]].hasOwnProperty(name)) {
            component = components.domains[Object.keys(components.domains)[0]][name];
        }
    }

    return component;
}